export default __webpack_public_path__ + "static/media/leader_inactive.f0ac27ce.svg";